export const coreTokensData = {
	fontFamily: {
		cssVar: '--cellula--font-family',
		value:
			"'Source Sans Pro', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
	},
	fontWeightRegular: {
		cssVar: '--cellula--font-weight--regular',
		value: '400',
	},
	fontWeightSemiBold: {
		cssVar: '--cellula--font-weight--semi-bold',
		value: '600',
	},
	textDisplayXlarge: {
		cssVar: '--cellula--text--display--x-large',
		value: 'var(--cellula--font-weight--semi-bold) 3.75rem/4.688rem var(--cellula--font-family)',
	},
	textDisplayLarge: {
		cssVar: '--cellula--text--display--large',
		value: `var(--cellula--font-weight--semi-bold) 3.375rem/4.188rem var(--cellula--font-family)`,
	},
	textDisplayMedium: {
		cssVar: '--cellula--text--display--medium',
		value: `var(--cellula--font-weight--semi-bold) 3rem/3.75rem var(--cellula--font-family)`,
	},
	textDisplaySmall: {
		cssVar: '--cellula--text--display--small',
		value: `var(--cellula--font-weight--semi-bold) 2.625rem/3.25rem var(--cellula--font-family)`,
	},
	textHeadingXlarge: {
		cssVar: '--cellula--text--heading--x-large',
		value: `var(--cellula--font-weight--semi-bold) 2.25rem/2.813rem var(--cellula--font-family)`,
	},
	textHeadingLarge: {
		cssVar: '--cellula--text--heading--large',
		value: `var(--cellula--font-weight--semi-bold) 2rem/2.5rem var(--cellula--font-family)`,
	},
	textHeadingMedium: {
		cssVar: '--cellula--text--heading--medium',
		value: `var(--cellula--font-weight--semi-bold) 1.75rem/2.188rem var(--cellula--font-family)`,
	},
	textHeadingSmall: {
		cssVar: '--cellula--text--heading--small',
		value: `var(--cellula--font-weight--semi-bold) 1.5rem/1.875rem var(--cellula--font-family)`,
	},
	textHeadingXsmall: {
		cssVar: '--cellula--text--heading--x-small',
		value: `var(--cellula--font-weight--semi-bold) 1.25rem/1.563rem var(--cellula--font-family)`,
	},
	textBodyLargeRegular: {
		cssVar: '--cellula--text--body--large-regular',
		value: `var(--cellula--font-weight--regular) 1.125rem/1.625rem var(--cellula--font-family)`,
	},
	textBodyLargeSemiBold: {
		cssVar: '--cellula--text--body--large-semi-bold',
		value: `var(--cellula--font-weight--semi-bold) 1.125rem/1.625rem var(--cellula--font-family)`,
	},
	textBodyRegular: {
		cssVar: '--cellula--text--body--regular',
		value: `var(--cellula--font-weight--regular) 1rem/1.5rem var(--cellula--font-family)`,
	},
	textBodySemiBold: {
		cssVar: '--cellula--text--body--semi-bold',
		value: `var(--cellula--font-weight--semi-bold) 1rem/1.5rem var(--cellula--font-family)`,
	},
	textBodySmallRegular: {
		cssVar: '--cellula--text--body--small-regular',
		value: `var(--cellula--font-weight--regular) 0.875rem/1.25rem var(--cellula--font-family)`,
	},
	textBodySmallSemiBold: {
		cssVar: '--cellula--text--body--small-semi-bold',
		value: `var(--cellula--font-weight--semi-bold) 0.875rem/1.25rem var(--cellula--font-family)`,
	},
	textLabelLargeRegular: {
		cssVar: '--cellula--text--label--large-regular',
		value: `var(--cellula--font-weight--regular) 1.125rem/1.375rem var(--cellula--font-family)`,
	},
	textLabelLargeSemiBold: {
		cssVar: '--cellula--text--label--large-semi-bold',
		value: `var(--cellula--font-weight--semi-bold) 1.125rem/1.375rem var(--cellula--font-family)`,
	},
	textLabelXlargeRegular: {
		cssVar: '--cellula--text--label--x-large-regular',
		value: `var(--cellula--font-weight--regular) 1.25rem/1.563rem var(--cellula--font-family)`,
	},
	textLabelXlargeSemiBold: {
		cssVar: '--cellula--text--label--x-large-semi-bold',
		value: `var(--cellula--font-weight--semi-bold) 1.125rem/1.563rem var(--cellula--font-family)`,
	},
	textLabelRegular: {
		cssVar: '--cellula--text--label--regular',
		value: `var(--cellula--font-weight--regular) 1rem/1.25rem var(--cellula--font-family)`,
	},
	textLabelSemiBold: {
		cssVar: '--cellula--text--label--semi-bold',
		value: `var(--cellula--font-weight--semi-bold) 1rem/1.25rem var(--cellula--font-family)`,
	},
	textLabelSmallRegular: {
		cssVar: '--cellula--text--label--small-regular',
		value: `var(--cellula--font-weight--regular) 0.875rem/1.125rem var(--cellula--font-family)`,
	},
	textLabelSmallSemiBold: {
		cssVar: '--cellula--text--label--small-semi-bold',
		value: `var(--cellula--font-weight--semi-bold) 0.875rem/1.125rem var(--cellula--font-family)`,
	},
	textLabelXsmallRegular: {
		cssVar: '--cellula--text--label--x-small-regular',
		value: `var(--cellula--font-weight--regular) 0.75rem/0.938rem var(--cellula--font-family)`,
	},
	textLabelXsmallSemiBold: {
		cssVar: '--cellula--text--label--x-small-semi-bold',
		value: `var(--cellula--font-weight--semi-bold) 0.75rem/0.938rem var(--cellula--font-family)`,
	},
	spacingX0_25: {
		cssVar: '--cellula--space--x0_25',
		value: '0.125rem',
	},
	spacingX0_5: {
		cssVar: '--cellula--space--x0_5',
		value: '0.25rem',
	},
	spacingX1: {
		cssVar: '--cellula--space--x1',
		value: '0.5rem',
	},
	spacingX1_5: {
		cssVar: '--cellula--space--x1_5',
		value: '0.75rem',
	},
	spacingX2: {
		cssVar: '--cellula--space--x2',
		value: '1rem',
	},
	spacingX2_5: {
		cssVar: '--cellula--space--x2_5',
		value: '1.25rem',
	},
	spacingX3: {
		cssVar: '--cellula--space--x3',
		value: '1.5rem',
	},
	spacingX4: {
		cssVar: '--cellula--space--x4',
		value: '2rem',
	},
	spacingX5: {
		cssVar: '--cellula--space--x5',
		value: '2.5rem',
	},
	spacingX6: {
		cssVar: '--cellula--space--x6',
		value: '3rem',
	},
	spacingX7: {
		cssVar: '--cellula--space--x7',
		value: '3.5rem',
	},
	spacingX8: {
		cssVar: '--cellula--space--x8',
		value: '4rem',
	},
	spacingX9: {
		cssVar: '--cellula--space--x9',
		value: '4.5rem',
	},
	sizeX0_25: {
		cssVar: '--cellula--size--x0_25',
		value: '0.125rem',
	},
	sizeX0_5: {
		cssVar: '--cellula--size--x0_5',
		value: '0.25rem',
	},
	sizeX1: {
		cssVar: '--cellula--size--x1',
		value: '0.5rem',
	},
	sizeX1_5: {
		cssVar: '--cellula--size--x1_5',
		value: '0.75rem',
	},
	sizeX2: {
		cssVar: '--cellula--size--x2',
		value: '1rem',
	},
	sizeX2_5: {
		cssVar: '--cellula--size--x2_5',
		value: '1.25rem',
	},
	sizeX3: {
		cssVar: '--cellula--size--x3',
		value: '1.5rem',
	},
	sizeX4: {
		cssVar: '--cellula--size--x4',
		value: '2rem',
	},
	sizeX5: {
		cssVar: '--cellula--size--x5',
		value: '2.5rem',
	},
	sizeX6: {
		cssVar: '--cellula--size--x6',
		value: '3rem',
	},
	sizeX7: {
		cssVar: '--cellula--size--x7',
		value: '3.5rem',
	},
	sizeX8: {
		cssVar: '--cellula--size--x8',
		value: '4rem',
	},
	sizeX9: {
		cssVar: '--cellula--size--x9',
		value: '4.5rem',
	},
	elevationSkim: {
		cssVar: '--cellula--elevation--skim',
		value: '0px 1px 2px rgba(47, 49, 56, 0.2)',
	},
	elevationLifted: {
		cssVar: '--cellula--elevation--lifted',
		value: '0px 2px 6px rgba(47, 49, 56, 0.18)',
	},
	elevationFloating: {
		cssVar: '--cellula--elevation--floating',
		value: '0px 4px 14px rgba(47, 49, 56, 0.16)',
	},
	elevationFlying: {
		cssVar: '--cellula--elevation--flying',
		value: '0px 6px 22px rgba(47, 49, 56, 0.14)',
	},
	borderRadiusXsmall: {
		cssVar: '--cellula--border-radius--x-small',
		value: '0.25rem',
	},
	borderRadiusSmall: {
		cssVar: '--cellula--border-radius--small',
		value: '0.5rem',
	},
	borderRadiusMedium: {
		cssVar: '--cellula--border-radius--medium',
		value: '0.75rem',
	},
	borderRadiusLarge: {
		cssVar: '--cellula--border-radius--large',
		value: '1rem',
	},
	borderRadiusPill: {
		cssVar: '--cellula--border-radius--pill',
		value: '9999rem',
	},
	borderRadiusCircle: {
		cssVar: '--cellula--border-radius--circle',
		value: '50%',
	},
};

export interface CoreTokens {
	text: {
		display: {
			xLarge: string;
			large: string;
			medium: string;
			small: string;
		};
		heading: {
			xLarge: string;
			large: string;
			medium: string;
			small: string;
			xSmall: string;
		};
		body: {
			largeRegular: string;
			largeSemiBold: string;
			regular: string;
			semiBold: string;
			smallRegular: string;
			smallSemiBold: string;
		};
		label: {
			xLargeRegular: string;
			xLargeSemiBold: string;
			largeRegular: string;
			largeSemiBold: string;
			regular: string;
			semiBold: string;
			smallRegular: string;
			smallSemiBold: string;
			xSmallRegular: string;
			xSmallSemiBold: string;
		};
	};
	spacing: {
		/** 2px */
		x0_25: string;

		/** 4px */
		x0_5: string;

		/** 8px */
		x1: string;

		/** 12px */
		x1_5: string;

		/** 16px */
		x2: string;

		/** 20px */
		x2_5: string;

		/** 24px */
		x3: string;

		/** 32px */
		x4: string;

		/** 40px */
		x5: string;

		/** 48px */
		x6: string;

		/** 56px */
		x7: string;

		/** 64px */
		x8: string;

		/** 72px */
		x9: string;
	};
	size: {
		/** 2px */
		x0_25: string;

		/** 4px */
		x0_5: string;

		/** 8px */
		x1: string;

		/** 12px */
		x1_5: string;

		/** 16px */
		x2: string;

		/** 20px */
		x2_5: string;

		/** 24px */
		x3: string;

		/** 32px */
		x4: string;

		/** 40px */
		x5: string;

		/** 48px */
		x6: string;

		/** 56px */
		x7: string;

		/** 64px */
		x8: string;

		/** 72px */
		x9: string;
	};
	elevation: {
		/** 0px 1px 2px */
		skim: string;

		/** 0px 2px 6px */
		lifted: string;

		/** 0px 4px 14px */
		floating: string;

		/** 0px 6px 22px */
		flying: string;
	};
	borderRadius: {
		/** 4px */
		xSmall: string;

		/** 8px */
		small: string;

		/** 12px */
		medium: string;

		/** 16px */
		large: string;

		/** 9999rem */
		pill: string;

		/** 50% */
		circle: string;
	};
	breakpointQuery: {
		/** min-width: 600px */
		small: string;

		/** min-width: 905px */
		medium: string;

		/** min-width: 1440px */
		large: string;
	};
}

export const coreTokens: CoreTokens = {
	text: {
		display: {
			xLarge: `var(${coreTokensData.textDisplayXlarge.cssVar})`,
			large: `var(${coreTokensData.textDisplayLarge.cssVar})`,
			medium: `var(${coreTokensData.textDisplayMedium.cssVar})`,
			small: `var(${coreTokensData.textDisplaySmall.cssVar})`,
		},
		heading: {
			xLarge: `var(${coreTokensData.textHeadingXlarge.cssVar})`,
			large: `var(${coreTokensData.textHeadingLarge.cssVar})`,
			medium: `var(${coreTokensData.textHeadingMedium.cssVar})`,
			small: `var(${coreTokensData.textHeadingSmall.cssVar})`,
			xSmall: `var(${coreTokensData.textHeadingXsmall.cssVar})`,
		},
		body: {
			largeRegular: `var(${coreTokensData.textBodyLargeRegular.cssVar})`,
			largeSemiBold: `var(${coreTokensData.textBodyLargeSemiBold.cssVar})`,
			regular: `var(${coreTokensData.textBodyRegular.cssVar})`,
			semiBold: `var(${coreTokensData.textBodySemiBold.cssVar})`,
			smallRegular: `var(${coreTokensData.textBodySmallRegular.cssVar})`,
			smallSemiBold: `var(${coreTokensData.textBodySmallSemiBold.cssVar})`,
		},
		label: {
			xLargeRegular: `var(${coreTokensData.textLabelXlargeRegular.cssVar})`,
			xLargeSemiBold: `var(${coreTokensData.textLabelXlargeSemiBold.cssVar})`,
			largeRegular: `var(${coreTokensData.textLabelLargeRegular.cssVar})`,
			largeSemiBold: `var(${coreTokensData.textLabelLargeSemiBold.cssVar})`,
			regular: `var(${coreTokensData.textLabelRegular.cssVar})`,
			semiBold: `var(${coreTokensData.textLabelSemiBold.cssVar})`,
			smallRegular: `var(${coreTokensData.textLabelSmallRegular.cssVar})`,
			smallSemiBold: `var(${coreTokensData.textLabelSmallSemiBold.cssVar})`,
			xSmallRegular: `var(${coreTokensData.textLabelXsmallRegular.cssVar})`,
			xSmallSemiBold: `var(${coreTokensData.textLabelXsmallSemiBold.cssVar})`,
		},
	},
	spacing: {
		x0_25: `var(${coreTokensData.spacingX0_25.cssVar})`,
		x0_5: `var(${coreTokensData.spacingX0_5.cssVar})`,
		x1: `var(${coreTokensData.spacingX1.cssVar})`,
		x1_5: `var(${coreTokensData.spacingX1_5.cssVar})`,
		x2: `var(${coreTokensData.spacingX2.cssVar})`,
		x2_5: `var(${coreTokensData.spacingX2_5.cssVar})`,
		x3: `var(${coreTokensData.spacingX3.cssVar})`,
		x4: `var(${coreTokensData.spacingX4.cssVar})`,
		x5: `var(${coreTokensData.spacingX5.cssVar})`,
		x6: `var(${coreTokensData.spacingX6.cssVar})`,
		x7: `var(${coreTokensData.spacingX7.cssVar})`,
		x8: `var(${coreTokensData.spacingX8.cssVar})`,
		x9: `var(${coreTokensData.spacingX9.cssVar})`,
	},
	size: {
		x0_25: `var(${coreTokensData.sizeX0_25.cssVar})`,
		x0_5: `var(${coreTokensData.sizeX0_5.cssVar})`,
		x1: `var(${coreTokensData.sizeX1.cssVar})`,
		x1_5: `var(${coreTokensData.sizeX1_5.cssVar})`,
		x2: `var(${coreTokensData.sizeX2.cssVar})`,
		x2_5: `var(${coreTokensData.sizeX2_5.cssVar})`,
		x3: `var(${coreTokensData.sizeX3.cssVar})`,
		x4: `var(${coreTokensData.sizeX4.cssVar})`,
		x5: `var(${coreTokensData.sizeX5.cssVar})`,
		x6: `var(${coreTokensData.sizeX6.cssVar})`,
		x7: `var(${coreTokensData.sizeX7.cssVar})`,
		x8: `var(${coreTokensData.sizeX8.cssVar})`,
		x9: `var(${coreTokensData.sizeX9.cssVar})`,
	},
	elevation: {
		skim: `var(${coreTokensData.elevationSkim.cssVar})`,
		lifted: `var(${coreTokensData.elevationLifted.cssVar})`,
		floating: `var(${coreTokensData.elevationFloating.cssVar})`,
		flying: `var(${coreTokensData.elevationFlying.cssVar})`,
	},
	borderRadius: {
		xSmall: `var(${coreTokensData.borderRadiusXsmall.cssVar})`,
		small: `var(${coreTokensData.borderRadiusSmall.cssVar})`,
		medium: `var(${coreTokensData.borderRadiusMedium.cssVar})`,
		large: `var(${coreTokensData.borderRadiusLarge.cssVar})`,
		pill: `var(${coreTokensData.borderRadiusPill.cssVar})`,
		circle: `var(${coreTokensData.borderRadiusCircle.cssVar})`,
	},
	breakpointQuery: {
		small: '@media screen and (min-width: 600px)',
		medium: '@media screen and (min-width: 905px)',
		large: '@media screen and (min-width: 1440px)',
	},
};
